import Entity from './entity';
export default class Currency extends Entity<string> {
  name: string;
  symbol: string;
}
